import React, { useEffect, useState } from "react";
import AdminPanelGeneralHeading from "../components/AdminPanelGeneralHeading";
import { useNavigate, useParams } from "react-router-dom";
import ErrorAlert from "../components/ErrorAlert";
import SuccessAlert from "../components/SuccessAlert";

export default function UpdateRoom() {
  const { roomId } = useParams();
  const navigate = useNavigate();

  // State Handling
  const [roomsData, setRoomsData] = useState({
    room_imgOne: "",
    room_imgTwo: "",
    room_imgThree: "",
    room_name: "",
    room_number: "",
    room_hotel_name: "",
    room_city: "",
    room_beds: "",
    room_area: "",
    room_per_day_price: "",
    room_description: "",
    room_amenities: [
      {
        ra_one: "",
        ra_two: "",
        ra_three: "",
        ra_four: "",
        ra_five: "",
        ra_six: "",
        ra_seven: "",
        ra_eight: "",
      },
    ],
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [placesData, setPlacesData] = useState();
  const [hotelsData, setHotelsData] = useState();
  const [loading, setLoading] = useState(false);

  // --------- Reading/Fetching Hotels From Database ---------
  const readingHotels = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-hotels"
    );
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Hotels can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setHotelsData(result);
    }
  };

  // --------- Reading/Fetching Places From Database ---------
  const readingPlaces = async () => {
    const response = await fetch(
      "https://hotelbnb-backend.onrender.com/read-places"
    );
    const result = await response.json();

    if (!response.ok) {
      setSuccess("");
      setError("Places can't be fetched");
    } else if (response.ok) {
      setTimeout(() => {
        setError("");
      }, 10000);
      setPlacesData(result);
    }
  };

  // Upload Images Handling
  const roomImgHandler = (e, room_imgNumberParam) => {
    const room_imgNumber = room_imgNumberParam;
    const imgFile = e.target.files[0];
    if (imgFile) {
      const imgReader = new FileReader();
      imgReader.readAsDataURL(imgFile);
      imgReader.onloadend = () => {
        setRoomsData({
          ...roomsData,
          [room_imgNumber]: imgReader.result,
        });
      };
      imgReader.onerror = (error) => {
        console.log(error);
      };
    }
  };

  //   Get Room's Data
  const singleRoom = async () => {
    const response = await fetch(
      `https://hotelbnb-backend.onrender.com/room/${roomId}`
    );
    const result = await response.json();

    if (response.ok) {
      setRoomsData(result);
    }
  };

  // Form Submission To Update Room In DataBase
  const updateRoomsSubmitHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setLoading(true);

    try {
      const response = await fetch(
        `https://hotelbnb-backend.onrender.com/edit-room/${roomId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(roomsData),
        }
      );
      const result = await response.json();

      if (response.ok) {
        setSuccess("Room Updated!");

        setTimeout(() => {
          navigate("/admin/add-rooms");
        }, 1000);
      } else if (!response.ok) {
        setError("Update Failed! Please Try Again");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    singleRoom();
    readingHotels();
    readingPlaces();
  }, []);

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Updating Room</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Showing Alert based on http request response Start */}
        {success && <SuccessAlert successMsg={success} />}
        {error && <ErrorAlert errorMsg={error} />}
        {/* Showing Alert based on http request response End */}

        {/*  Update Room Heading Start */}
        <AdminPanelGeneralHeading text="Update Room" />
        {/*  Update Room Heading End */}

        {/* Update Room Form Start */}
        <div className="col-12 add-places-form-cover signup-form-cover">
          <form
            method="post"
            className="p-0"
            onSubmit={updateRoomsSubmitHandler}
          >
            {/* Row 1 */}
            <div className="d-flex gap-4 justify-content-center align-items-center single-room-imgs-cover">
              {/* Image 1 */}
              <div className="p-0 m-0 upload-room-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                <i className="fa-solid fa-camera"></i>
                <input
                  type="file"
                  name="room_imgOne"
                  className="profile-pic-input"
                  onChange={(e) => {
                    roomImgHandler(e, "room_imgOne");
                  }}
                />
                {roomsData.room_imgOne ? (
                  <img
                    src={roomsData.room_imgOne}
                    alt="room-img"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>

              {/* Image 2 */}
              <div className="p-0 m-0 upload-room-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                <i className="fa-solid fa-camera"></i>
                <input
                  type="file"
                  name="room_imgTwo"
                  className="profile-pic-input"
                  onChange={(e) => {
                    roomImgHandler(e, "room_imgTwo");
                  }}
                />
                {roomsData.room_imgTwo ? (
                  <img
                    src={roomsData.room_imgTwo}
                    alt="room-img"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>

              {/* Image 3 */}
              <div className="p-0 m-0 upload-room-pic-cover upload-profile-pic-cover d-flex justify-content-center align-items-center position-relative">
                <i className="fa-solid fa-camera"></i>
                <input
                  type="file"
                  name="room_imgThree"
                  className="profile-pic-input"
                  onChange={(e) => {
                    roomImgHandler(e, "room_imgThree");
                  }}
                />
                {roomsData.room_imgThree ? (
                  <img
                    src={roomsData.room_imgThree}
                    alt="room-img"
                    className="img-fluid"
                  />
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Row 2 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="room_name"
                  placeholder="Room Name"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_name}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_name: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="room_number"
                  placeholder="Room Number"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_number}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_number: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>

              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="room_max_people"
                  placeholder="Room Max People"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_max_people}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_max_people: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 3 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <select
                  name="room_hotel_name"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_hotel_name}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_hotel_name: e.target.value,
                    });
                  }}
                >
                  <option value="Select the Hotel">Select the Hotel</option>
                  {hotelsData?.map((optionVal) => {
                    return (
                      <option key={optionVal._id} value={optionVal.hotel_name}>
                        {optionVal.hotel_name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col p-0 signup-col">
                <select
                  name="room_city"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_city}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_city: e.target.value,
                    });
                  }}
                >
                  <option value="Select the city">Select the city</option>
                  {placesData?.map((optionVal) => {
                    return (
                      <option key={optionVal._id} value={optionVal.place_city}>
                        {optionVal.place_city}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            {/* Row 4 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="room_beds"
                  placeholder="How many Beds"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_beds}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_beds: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="room_area"
                  placeholder="Area in Numbers"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_area}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_area: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 5 */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="number"
                  name="room_per_day_price"
                  placeholder="Per Day Price"
                  className="form-control"
                  required
                  value={roomsData.room_per_day_price}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_per_day_price: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="room_description"
                  placeholder="Room Description"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_description}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_description: e.target.value.toLowerCase(),
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 6 Amenities */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_one"
                  placeholder="Amenity 01"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_one}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_one: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_two"
                  placeholder="Amenity 02"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_two}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_two: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_three"
                  placeholder="Amenity 03"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_three}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_three: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_four"
                  placeholder="Amenity 04"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_four}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_four: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
            </div>

            {/* Row 7 Amenities */}
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_five"
                  placeholder="Amenity 05"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_five}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_five: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_six"
                  placeholder="Amenity 06"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_six}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_six: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_seven"
                  placeholder="Amenity 07"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_seven}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_seven: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <input
                  type="text"
                  name="amenity_eight"
                  placeholder="Amenity 08"
                  className="form-control text-capitalize"
                  required
                  value={roomsData.room_amenities[0].ra_eight}
                  onChange={(e) => {
                    setRoomsData({
                      ...roomsData,
                      room_amenities: [
                        {
                          ...roomsData.room_amenities[0],
                          ra_eight: e.target.value.toLowerCase(),
                        },
                      ],
                    });
                  }}
                />
              </div>
            </div>

            {/* Submit Btn */}
            <button
              type="submit"
              className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
            >
              Update Room
            </button>
          </form>
        </div>
        {/* Update Room Form End */}
      </>
    );
}
